'use client'

import React from 'react'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface ServiceItem {
  image: string
  title: string
  description: string
}

const Services: React.FC = () => {
  const router = useRouter()
  const { openProjectModal } = useModal()

  const services: ServiceItem[] = [
    {
      image: '/images/integrations/services_1.svg',
      title: 'Интеграция с 1С',
      description: 'Интегрируем вашу базу данных 1С с внешними ИТ‑продуктами для автоматизации учёта. Настраиваем бесшовный обмен данными: от актуальных остатков и номенклатуры до статусов заказов и взаиморасчётов.'
    },
    {
      image: '/images/integrations/services_2.svg',
      title: 'Интеграции с банками',
      description: 'Автоматизируем финансовые операции совместно с банковскими системами. Настраиваем цикл работы с платежами внутри вашей системы: от момента формирования счета до подтверждения зачисления средств.'
    },
    {
      image: '/images/integrations/services_3.svg', 
      title: 'CRM',
      description: 'Создаём среду, где все процессы компании собраны в одном окне. Настраиваем сквозную автоматизацию: от ведения клиентской базы до контроля KPI и управления проектами с помощью контроля сроков и канбан-досок.'
    },
    {
      image: '/images/integrations/services_4.svg', 
      title: 'Системные интеграции',
      description: 'Разрабатываем шлюзы для связки любых программных продуктов, независимо от их назначения и отрасли. Мы проектируем безопасные каналы передачи данных между любым ПО и аналитическими системами.'
    }
  ]

  const handleButtonClick = (index: number) => {
    if (index === 0 || index === 2) {
      router.push('/portfolio/partner-b2b/')
    } else if (index === 1) {
      router.push('/portfolio/multibanking/')
    } else if (index === 3) {
      router.push('/portfolio/materials-marketplace/')
    }
  }

  return (
    <section className={styles.section}>
      <AnimatedSection animation="slideUp">
        <div className={styles.heading}>
          <div className={styles.subtitle}>Услуги</div>
          <h2 
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: '<span>Связываем ваши сервисы</span> в единую рабочую среду' }}
          />
        </div>
      </AnimatedSection>

      <AnimatedSection animation="slideUp">
        <div className={styles.grid}>
          {services.map((item, idx) => (
            <div key={idx} className={styles.card}>
              <div className={styles.imageContainer}>
                <Image
                  src={item.image}
                  alt={item.title}
                  width={460}
                  height={178}
                  className={styles.image}
                />
              </div>
              <div className={styles.content}>
                <h3 className={styles.cardTitle}>
                  {item.title}
                </h3>
                <p className={styles.cardDescription}>
                  {item.description}
                </p>
                <button 
                  className={styles.button}
                  onClick={() => handleButtonClick(idx)}
                >
                  <span className={styles.buttonText}>Подробнее об услуге</span>
                  <svg className={styles.buttonIcon} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </AnimatedSection>
    </section>
  )
}

Services.displayName = 'Services'

export default Services